import { createContext } from 'react'
import { EnrollStepContextType } from '../types'

export const EnrollStepContext = createContext<EnrollStepContextType>(null)
